var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"observer",attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
var errors = ref.errors;
return [_c('form',_vm._g(_vm._b({on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",null,{"invalid":invalid,"errors":errors})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }